import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

/**
 * Shimmering placeholder rows for list-style dashboard widgets.
 *
 *   <gs-skeleton-list rows="5" variant="row"></gs-skeleton-list>
 *   <gs-skeleton-list rows="4" variant="activity"></gs-skeleton-list>
 *
 * `row` — avatar + two text lines + a trailing pill (Active Jobs,
 *         Active Candidates, Offers, Recent Submissions).
 * `activity` — small dot + one wide text line + small time chip
 *         (Today's Activity).
 */
@Component({
  selector: 'gs-skeleton-list',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './skeleton-list.component.html',
  styleUrls: ['./skeleton-list.component.scss'],
})
export class SkeletonListComponent {
  @Input() rows = 5;
  @Input() variant: 'row' | 'activity' = 'row';

  get range(): number[] {
    const n = Math.max(1, Math.min(20, Number(this.rows) || 5));
    return Array.from({ length: n }, (_, i) => i);
  }
}
